export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
}